import { useState, useEffect } from "react";
import "./dropdownMenu.css";
import PropTypes from "prop-types";
import { Form, FormGroup, FormLabel } from "react-bootstrap";

const DropdownMenu = ({
  dropdownLabel,
  dropdownName,
  dropdownOptions,
  selectedOption,
  selectOption,
}) => {
  const [value, setValue] = useState(selectedOption);

  useEffect(() => {
    setValue(selectedOption);
  }, [selectedOption]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    selectOption(newValue);
  };

  const dropdownOptionsJSX = dropdownOptions.map((dropdownOption, i) => (
    <option key={i} value={dropdownOption}>
      {dropdownOption}
    </option>
  ));

  return (
    <FormGroup className="form-group">
      <FormLabel className="form-label">{dropdownLabel}:</FormLabel>
      <Form.Select
        value={value}
        name={dropdownLabel}
        className={dropdownName}
        onChange={handleChange}
      >
        {dropdownOptionsJSX}
      </Form.Select>
    </FormGroup>
  );
};

DropdownMenu.propTypes = {
  selectedOption: PropTypes.string,
  selectOption: PropTypes.func,
  dropdownOptions: PropTypes.array,
  dropdownLabel: PropTypes.string,
  dropdownName: PropTypes.string,
};

export default DropdownMenu;
